<template>
<!--  <el-form label-position="left" label-width="0px" class="demo-ruleForm login-container">-->
<!--    <h3 class="title">SSO to the  Portal</h3>-->
<!--  </el-form>-->
</template>

<script>
import {
  login, loginSSO
} from '../api/api';
export default {
  data() {
    return {
      logining: false,
    };
  },
  mounted() {
    const url = new URL(window.location.href);
// 获取 URLSearchParams 对象
    const params = new URLSearchParams(url.search);
    console.log(params,'params')
// 获取 code 参数的值
    const code = params.get('code');
    console.log(code,'code')
    loginSSO({
      codeVerifier: sessionStorage.getItem('codeVerifier'),
      codeChallenge: sessionStorage.getItem('codeChallenge'),
      code: code
    }).then(res => {
      sessionStorage.setItem('userId', res.data.nUserId);
      sessionStorage.setItem('token', res.data.token);
      sessionStorage.setItem('sName', res.data.sName);
      sessionStorage.setItem('dLastLogin', res.data.dLastLogin);
      sessionStorage.setItem('sRole', res.data.sAuthority);
      sessionStorage.setItem('sRoleName', res.data.sRole);
      if (res.data.sAuthority == "") {
        this.$router.replace('/no');
      } else if (res.data.sAuthority.indexOf('Data') > -1) {
        const id = sessionStorage.getItem('id');
        if (id == null) {
          this.$router.replace({ path: '/select' });
        } else {
          this.$router.replace({ path: `/select?id=${id}` })
          sessionStorage.removeItem('id');
        }
      } else if (res.data.sAuthority.indexOf('Admin') > -1) {
        this.$router.replace('/user');
      } else if (res.data.sAuthority.indexOf('Upload') > -1) {
        this.$router.replace('/template');
      }
    });
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.login-container {
  /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-border-radius: 5px;
  background-clip: padding-box;
  margin: 180px auto;
  width: 600px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
  .title {
    margin: 0px auto 40px auto;
    text-align: center;
    font-size:30px;
    color: #505458;
  }
  .remember {
    margin: 0px 0px 35px 0px;
  }
  .el-form-item{
    margin-bottom: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// sso.vue?667b0db3